const menuItems = {
  items: [
    {
      id: 'patient-info',
      title: 'Patient Information',
      type: 'group',
      backIcon: 'fa fa-chevron-left',
      backUrl: '/hospital/hosp-patient',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'ckd-icon ckd-ckdoctor-logo',
          url: '/patient/info/dashboard/99999',
          departmentList: ['all', 'ipd'],
        },
        {
          id: 'history',
          title: 'History',
          type: 'item',
          icon: 'fa fa-history',
          url: '/patient/dashboard/analytics/888888',
        },
        {
          id: 'timeline',
          title: 'Timeline',
          type: 'item',
          icon: 'fa fa-clock',
          url: '/patient/info/timeline/88888',
        },
        {
          id: 'activities',
          title: 'Activities',
          type: 'item',
          icon: 'fa fa-running',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'hosp-module-history',
          title: 'History Compare',
          type: 'item',
          icon: 'fa fa-balance-scale',
          url: '/patient/info/hosp-module-history/88888',
        },
        {
          id: 'adr',
          title: 'Adr',
          type: 'item',
          icon: 'fa fa-allergies',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'bed-history',
          title: 'Bed History',
          type: 'item',
          icon: 'ckd-icon ckd-bed-history',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'vaccine',
          title: 'Vaccine',
          type: 'item',
          icon: 'ckd-icon ckd-vaccine',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'appointment',
          title: 'Appointment',
          type: 'item',
          icon: 'fa fa-calendar-check',
          url: '/patient/dashboard/analytics/88888',
        },
      ],
    },
    {
      id: 'patient-visit',
      title: 'Patient Visit',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'documents',
          title: 'Documents',
          type: 'item',
          icon: 'feather icon-file-text',
          url: '/patient/info/hosp-document/88888',
        },
        {
          id: 'image',
          title: 'Images',
          type: 'item',
          icon: 'feather icon-image',
          url: '/patient/info/hosp-images/88888',
        },
        {
          id: 'patient-evaluation',
          title: 'Patient Evaluation',
          type: 'item',
          icon: 'fa fa-stethoscope',
          url: '/patient/info/patient-evaluation/88888',
        },
        {
          id: 'laboratory',
          title: 'Laboratory',
          type: 'item',
          icon: 'ckd-icon ckd-lab',
          url: '/patient/info/hosp-laboratory/88888',
        },
        {
          id: 'radiology',
          title: 'Radiology',
          type: 'item',
          icon: 'fa fa-radiation-alt',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'prescription',
          title: 'Prescription',
          type: 'item',
          icon: 'fa fa-file-prescription',
          url: '/patient/info/prescription/88888',
        },
        {
          id: 'billing',
          title: 'Billing',
          type: 'item',
          icon: 'fa fa-money-bill-alt',
          url: '/patient/info/billing/88888',
        },
        {
          id: 'finance',
          title: 'Financial',
          type: 'item',
          icon: 'fa fa-money-bill-alt',
          url: '/patient/info/hosp-invoice/88888',
        },
      ],
    },
    {
      id: 'specialty',
      title: 'Specialty',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'dental-treatment',
          title: 'Dental Treatment',
          type: 'item',
          icon: 'fas fa-tooth',
          url: '/patient/info/hosp-dental/88888',
        },
        {
          id: 'surgery',
          title: 'Surgery',
          type: 'item',
          icon: 'fa fa-procedures',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'accident',
          title: 'Accident',
          type: 'item',
          icon: 'fa fa-user-injured ',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'Social-work',
          title: 'Social Work',
          type: 'item',
          icon: 'ckd-icon ckd-social-work',
          url: '/patient/info/hosp-genogram/88888',
        },
        {
          id: 'psychology',
          title: 'Psychology',
          type: 'item',
          icon: 'fa fa-brain',
          url: '/patient/dashboard/analytics/88888',
        },
      ],
    },
    {
      id: 'in-patient-treatment',
      title: 'In-Patient Treatment',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'admission-note',
          title: 'Admission Note',
          type: 'item',
          icon: 'ckd-icon ckd-admission-note',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'order',
          title: 'Order / Progression Note',
          type: 'item',
          icon: 'fa fa-pen',
          url: '/patient/info/order/88888',
        },
        {
          id: 'vital-sign-record',
          title: 'Vital Sign Record',
          type: 'item',
          icon: 'ckd-icon ckd-vitalsign-record',
          url: '/patient/info/vital-sign/88888',
        },
        {
          id: 'vital-sign-chart',
          title: 'Vital Sign Chart',
          type: 'item',
          icon: 'ckd-icon ckd-vitalsign-chart',
          url: '/patient/info/vital-sign-chart/88888',
        },
        {
          id: 'treatment-plan',
          title: 'Treatment Plan',
          type: 'item',
          icon: 'ckd-icon ckd-treatment-plan',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'focus-note',
          title: 'Focus Note',
          type: 'item',
          icon: 'fa fa-users',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'nurse-note',
          title: 'Nurse Note',
          type: 'item',
          icon: 'fas fa-notes-medical',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'nutrition',
          title: 'Nutrition',
          type: 'item',
          icon: 'fa fa-fish',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'therapies',
          title: 'Therapies Calendar',
          type: 'item',
          icon: 'fa fa-medkit',
          url: '/patient/ipd/therapies-calendar/88888',
        },
        {
          id: 'e-mar',
          title: 'eMar',
          type: 'item',
          icon: 'fa fa-medkit',
          url: '/patient/ipd/e-mar/88888',
        },
        {
          id: 'consult-request',
          title: 'Consult Request',
          type: 'item',
          icon: 'fa fa-paper-plane',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'clinical-summary',
          title: 'Clinical Summary',
          type: 'item',
          icon: 'fa fa-diagnoses',
          url: '/patient/dashboard/analytics/88888',
        },
        {
          id: 'dc-summary',
          title: 'D/C Summary',
          type: 'item',
          icon: 'fa fa-trophy',
          url: '/patient/dashboard/analytics/88888',
        },
      ],
    },
  ],
}

export default menuItems
